'use client';

export { default } from './TableContainer';
export { default as tableContainerClasses } from './tableContainerClasses';
export * from './tableContainerClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableContainer/index.js
// module id = 966
// module chunks = 25